import Macbook from '../assets/projectsImgs/macbook.png';
import Strans from '../assets/projectsImgs/strans.png';
import Facebook from '../assets/projectsImgs/facebook.png';
import BootstrapCheatsheet from '../assets/projectsImgs/bootstrap-cheatsheet.png';
import Bookstore from '../assets/projectsImgs/shane-bookstore.png';
import FirstWebsite from '../assets/projectsImgs/firstwebsite.png';

export const Work = [
  {
    id: 1,
    name: 'Strans App',
    description:
      "My first React website. It's a website I designed & code for a fake bank app called Strans.",
    tags: ['React', 'Css'],
    mockup: Macbook,
    image: Strans,
    demo: 'https://strans-app.netlify.app/',
    github: 'https://github.com/devShaneMantua/Strans-bankapp_website.git'
  },
  {
    id: 2,
    name: 'Facebook Clone',
    description:
      'A responsive Facebook clone created using Tailwind. It can be viewed in light & dark mode.',
    tags: ['Tailwind', 'Css', 'Html', 'JavaScript'],
    mockup: Macbook,
    image: Facebook,
    demo: 'https://facebook-cloned-ui.netlify.app',
    github: 'https://github.com/devShaneMantua/Facebook-UI-clone.git'
  },
  {
    id: 3,
    name: 'Cheatsheet',
    description:
      "It's a compilation of easy to copy Bootstrap Codes that I've learned. ",
    tags: ['Bootstrap', 'Html', 'Css'],
    mockup: Macbook,
    image: BootstrapCheatsheet,
    demo: 'https://bootstrap-cheatsheet.netlify.app',
    github: 'https://github.com/devShaneMantua/Bootstrap-Cheatsheet.git'
  },
  {
    id: 4,
    name: 'Online Bookstore',
    description:
      'For my second website, I created a online bookstore website but with no backend.',
    tags: ['Html', 'Css', 'JavaScript', 'Swiper Js'],
    mockup: Macbook,
    image: Bookstore,
    demo: 'https://shane-bookstore.netlify.app/',
    github: 'https://github.com/devShaneMantua/Shane-Bookstore.git'
  },
  {
    id: 5,
    name: 'My First Website',
    description:
      "The very first website and portfolio that I coded & designed.",
    tags: ['Html', 'Css', 'JavaScript'],
    mockup: Macbook,
    image: FirstWebsite,
    demo: 'https://shanedelmoira-firstwebsite.netlify.app/',
    github: 'https://github.com/devShaneMantua/ShaneM-Portfolio.git'
  }
];
